import React, { useEffect } from 'react';
import * as amplitude from '@amplitude/unified';
import { useCookieConsent } from '../contexts/CookieConsentContext';
import { flushPendingEvents, identifyAttribution } from '../utils/analytics';

export const AmplitudeInit: React.FC = () => {
  const { hasConsent } = useCookieConsent();

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    if (import.meta.env.DEV && !import.meta.env.VITE_AMPLITUDE_ENABLED) {
      return;
    }

    const apiKey = import.meta.env.VITE_AMPLITUDE_API_KEY;
    if (!apiKey) {
      return;
    }

    if (!hasConsent('analytics')) {
      if (window.__AMPLITUDE_INITIALIZED__) {
        amplitude.setOptOut(true);
      }
      return;
    }

    if (!window.__AMPLITUDE_INITIALIZED__) {
      void amplitude.initAll(apiKey, {
        serverZone: 'EU',
        analytics: {
          autocapture: {
            attribution: false,
            pageViews: false,
            sessions: false,
            formInteractions: false,
            fileDownloads: false,
            elementInteractions: false,
          },
        },
        sessionReplay: {
          sampleRate: 1,
        },
      }).then(() => {
        window.__AMPLITUDE_INITIALIZED__ = true;
        identifyAttribution();
        flushPendingEvents();
      });
    } else {
      amplitude.setOptOut(false);
      identifyAttribution();
    }
  }, [hasConsent]);

  return null;
};

declare global {
  interface Window {
    __AMPLITUDE_INITIALIZED__?: boolean;
  }
}
